import type { UseMutationOptions } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { queryKeys } from '../../services/query-key/query-keys';

export function useRemoveUser(userId: string, options?: UseMutationOptions<void, unknown, void>) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      const api = getPrivateApi();

      await api.removeUser({
        userId,
      });
    },
    ...options,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: queryKeys.users(),
      });
    },
  });
}
